<template>
  <div class="mt-3">
    <b-table :items="items" :fields="fields">
      <template v-slot:cell(value)="row">
        <div class="text-center">
          <b-form-checkbox
            name="check-button"
            switch
            size="lg"
            v-model="permissions[pKey][row.index].value"
          >
          </b-form-checkbox>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import idxSwitch from '@/components/atoms/switch';

export default {
  name: 'itemProfile',
  components: {
    idxSwitch,
  },
  computed: {
    ...mapState('profiles', ['permissions']),
  },
  props: {
    items: {
      type: Array,
    },
    fields: {
      type: Array,
    },
    pKey: {
      type: String,
    },
    busy: {
      type: Boolean,
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.table {
  thead {
    tr {
      &:nth-last-of-type() {
        text-align: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/settings/profiles/item-profile.vue